import { render } from "./VideoPlayerLive.vue?vue&type=template&id=7384d510&scoped=true"
import script from "./VideoPlayerLive.vue?vue&type=script&lang=js"
export * from "./VideoPlayerLive.vue?vue&type=script&lang=js"

import "./VideoPlayerLive.vue?vue&type=style&index=0&id=7384d510&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7384d510"]])

export default __exports__